import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "../lib/languages";

export const defaultLocale = "en" as const;

// Use centralized language configuration
export const locales = SUPPORTED_LANGUAGES as readonly SupportedLanguage[];

export type Locale = SupportedLanguage;
